import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Modal } from 'react-bootstrap';
import { useSelector } from "react-redux";
import axios from 'axios';
import uniqid from "uniqid";
import CryptoJS from 'crypto-js';
import { toast } from 'react-toastify';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';

function Slrec({ operatorCode }) {
  const currentUser = useSelector((state) => state.data);
  const [hash, setHash] = useState('');
  const [payuData, setPayuData] = useState({
    key: "s7VM7k3h",
    productinfo: "xxx",
    udf5: "BOLT_KIT_NODE_JS",
    salt: "VuCZddMYIp"
  });
  const [txId, setTxId] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const getAmount = (e) => {
    setTotalAmount(e.target.value);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const { Subscriber, Amount } = e.target;
    try {
      let txnid = uniqid();
      setTxId(txnid);
      let sendData = {
        service_provider: operatorCode,
        Subscriber: Subscriber.value,
        Amount: Amount.value,
        payment_txn: txnid
      };
      const response = await axios.post("/prabhuRecharge/getSLRECBill", sendData);
      const { Code, Message } = response.data;
      if (Code) {
        toast(Message);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };
  const getHash = () => {
    const hashString = `${payuData.key}|${txId}|${totalAmount}|${payuData.productinfo}|${currentUser?.name}|${currentUser?.email}|||||${payuData.udf5}||||||${payuData.salt}`;
    setHash(CryptoJS.SHA512(hashString).toString(CryptoJS.enc.Hex));
  };
  useEffect(() => {
    getHash();
  }, [totalAmount, currentUser, txId]);

  return (
    <>
      <Form onSubmit={handleSubmit}>
        <div className="row">
          <>
            <div class="col-lg-12 col-md-12">
              <label>Customer ID</label>
              <input type="text" class="form-control" name="Subscriber" required />
            </div>
            <div class="col-lg-12 col-md-12">
              <label>Amount</label>
              <input type="number" class="form-control" name="Amount" onChange={getAmount} required />
            </div>
            <div class="col-lg-12 col-md-12">
              <input type="submit" className="search-btn btn btn-primary" value="Pay" />
            </div>
          </>
        </div>
      </Form>
      <div>
        <form id="payuForm" name="payuForm" action={process.env.REACT_APP_PAYU_URL} method="POST" target="_blank">
          <input type="hidden" name="key" value={payuData.key} />
          <input type="hidden" name="hash" value={hash} />
          <input type="hidden" name="txnid" value={txId} />
          <input type="hidden" name="amount" value={totalAmount} />
          <input type="hidden" name="productinfo" value={payuData.productinfo} />
          <input type="hidden" name="firstname" value={currentUser?.name} />
          <input type="hidden" name="email" value={currentUser?.email} />
          <input type="hidden" name="udf5" value={payuData.udf5} />
          <input type="hidden" name="phone" value="" />
          <input type="hidden" name="surl" value={process.env.REACT_APP_FRONTEND_URL} />
          <input type="hidden" name="furl" value={process.env.REACT_APP_FRONTEND_URL} />
        </form>
      </div>
    </>
  );
}

export default Slrec;
